import {Text} from '@mantine/core';
import React from 'react';

import HelpButton from 'help/HelpButton';
import {DATE_TO_DISPLAY_WITH_LANGUAGE_TAG} from 'i18n/LanguageTagConstants';
import {ControlledLanguagePickerInput} from 'i18n/LanguageTags';
import LocalizationHelpBlock from 'i18n/LocalizationHelpBlock';
import FormGroup from 'ui-library/bs/FormGroup';

interface SpreadsheetLocaleSelectorProps {
  languageTag: string;
  onChange: (languageTag: string) => void;
  description?: string;
}

export function SpreadsheetLocaleSelector(props: SpreadsheetLocaleSelectorProps): JSX.Element {
  const dateToDisplay = new Date(DATE_TO_DISPLAY_WITH_LANGUAGE_TAG);
  const labelText = 'Data locale';
  return (
    <FormGroup>
      <label>{labelText}</label>
      <HelpButton
        renderContent={() => <LocalizationHelpBlock includeIgnoreIfExcelText={false} />}
        iconClassName="u-mini-spacing-left"
      />
      {props.description && (
        <Text size="sm" color="dimmed" mt="xs">
          {props.description}
        </Text>
      )}
      <ControlledLanguagePickerInput
        languageTag={props.languageTag}
        date={dateToDisplay}
        onSelect={(languageTag) => {
          props.onChange(languageTag);
        }}
      />
    </FormGroup>
  );
}
